"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ircsSheetSignalement = exports.ircsSheetRessource = exports.ircsSheetConcerne = void 0;
exports.ircsSheetConcerne = [
    {
        '@type': 'uuid-string',
        key: '7bbef4ac-e0f9-4c6c-aa09-ebb046dbad67',
        label: 'Sexe',
        value: bilan => bilan?.ircs_sheet?.victim_gender,
    },
    {
        '@type': 'text',
        key: '3781d4ac-d3f1-4e57-8777-79f4258350ef',
        label: 'Nom',
        value: bilan => bilan?.ircs_sheet?.victim_name,
    },
    {
        '@type': 'text',
        key: '0a81ae15-8e68-45a9-b07e-006a159e687f',
        label: 'Prénom',
        value: bilan => bilan?.ircs_sheet?.victim_first_name,
    },
    {
        '@type': 'text',
        key: 'f792973c-5c69-4ee9-b053-6fc98ebfcc14',
        label: 'Date de naissance',
        value: bilan => bilan?.ircs_sheet?.victim_birth,
    },
    {
        '@type': 'text',
        key: 'c46cf385-ede0-472a-91ca-fa5288764907',
        label: 'Adresse personnelle',
        value: bilan => bilan?.ircs_sheet?.victim_add,
    },
    {
        '@type': 'text',
        key: '081d42af-202b-48d8-bec0-2b6057f9a76a',
        label: 'Téléphone',
        value: bilan => bilan?.ircs_sheet?.victim_phone,
    },
    {
        '@type': 'text',
        key: '7c264f82-fd57-471b-ada9-58f8c22bd101',
        label: 'Mail',
        value: bilan => bilan?.ircs_sheet?.victim_mail,
    },
    {
        '@type': 'text',
        key: 'e70d05e6-5959-4c6d-b871-75127df837d0',
        label: 'Médecin traitant',
        value: bilan => bilan?.ircs_sheet?.medecin_traitant,
    },
];
exports.ircsSheetRessource = [
    {
        '@type': 'text',
        key: 'e0c8652b-4321-403d-932d-46e87be9de72',
        label: 'Nom',
        value: bilan => bilan?.ircs_sheet?.ressource_name,
    },
    {
        '@type': 'text',
        key: 'c8272e92-afba-4140-8d9c-d91e9d3fda87',
        label: 'Prénom',
        value: bilan => bilan?.ircs_sheet?.ressource_first_name,
    },
    {
        '@type': 'text',
        key: '7f9e7f59-7035-418a-a552-80ff4e508dfa',
        label: 'Adresse personnelle',
        value: bilan => bilan?.ircs_sheet?.ressource_add,
    },
    {
        '@type': 'text',
        key: '4d0f24fa-1625-4b8d-bd0c-89e4c3141799',
        label: 'Téléphone',
        value: bilan => bilan?.ircs_sheet?.ressource_phone,
    },
    {
        '@type': 'text',
        key: '191d2719-61f8-49d1-9ae5-b53c523105d4',
        label: 'Mail',
        value: bilan => bilan?.ircs_sheet?.ressource_mail,
    },
    {
        '@type': 'text',
        key: 'c9d0590f-72e9-41f3-b985-f153a92829ed',
        label: 'Lien avec la personne',
        value: bilan => bilan?.ircs_sheet?.ressource_link,
    },
];
exports.ircsSheetSignalement = [
    {
        '@type': 'uuid-string',
        key: '352db9d6-576c-4d3b-93a9-84fc11437225',
        label: 'Requérant',
        value: bilan => bilan?.ircs_sheet?.requerant,
    },
    {
        '@type': 'text',
        key: '39baa0f6-3baa-45dd-ade6-a0c3e55857f6',
        label: 'Requérant - Autre',
        value: bilan => bilan?.ircs_sheet?.requerant_autre,
    },
    {
        '@type': 'uuid-array',
        key: '5e25ab66-bc34-446a-8dc4-cf8fc3c81b6f',
        label: "Critère d'alerte",
        value: bilan => bilan?.ircs_sheet?.critere_alerte || [],
    },
    {
        '@type': 'uuid-string',
        key: '8f293363-7706-4e5a-9540-9d736e5c2c4c',
        label: 'Infirmiers à domicile',
        value: bilan => bilan?.ircs_sheet?.aides_infirmiers,
    },
    {
        '@type': 'uuid-string',
        key: '11472fcd-e6e7-4726-8b1e-e16bf7f92aba',
        label: 'Aide à domicile',
        value: bilan => bilan?.ircs_sheet?.aides_domicile,
    },
    {
        '@type': 'tristate',
        key: '5a7bfb31-7a09-488f-aeb9-b637a0d175a3',
        label: 'Personne informé de la transmission de ces informations',
        value: bilan => bilan?.ircs_sheet?.personne_informee_demarche,
    },
    {
        '@type': 'text',
        key: '42ee184f-0b17-4912-a93e-cf764b01c8a3',
        label: 'Autres informations utiles',
        value: bilan => bilan?.ircs_sheet?.autre_infos,
    },
    {
        '@type': 'text',
        key: '9a72277e-ec72-4e30-a373-4d0bb7f53ef2',
        label: 'Commentaire',
        value: bilan => bilan?.ircs_sheet?.commentaire,
    },
];
